(function () {
  'use strict';
  const Cls=window.AAHeadquartersClients;
  if (!Cls?.prototype || Cls.prototype.__aaContactsFeature) return;
  const p=Cls.prototype, TABLE='aa_client_contacts';
  const state=ctx=>ctx.__aaExtraContacts||(ctx.__aaExtraContacts=new Map());
  const esc=(ctx,x)=>ctx.escapeHtml(String(x??''));
  const rows=ctx=>state(ctx).get(String(ctx.activeClientId))?.rows||[];
  function display(ctx,clientId,editable) {
    const entry=state(ctx).get(String(clientId));
    if (!entry || entry.loading) return '<p>Loading contacts...</p>';
    if (entry.error) return '<p role="alert">Contacts could not load: '+esc(ctx,entry.error)+'</p>';
    if (!entry.rows.length) return editable ? '<p>No additional contacts yet.</p>' : '';
    return entry.rows.map(person=>[
      '<div class="aa-contact-card">',
      '<div class="aa-contact-card__name"><strong>',esc(ctx,person.full_name),'</strong>',
      '<span>',esc(ctx,person.contact_role),'</span></div>',
      person.email?'<div>'+esc(ctx,person.email)+'</div>':'',
      person.phone?'<div>'+esc(ctx,person.phone)+'</div>':'',
      editable?'<div class="aa-contact-card__actions"><button type="button" data-aa-contact-edit="'+esc(ctx,person.id)+'">Edit</button>'+
        '<button type="button" data-aa-contact-remove="'+esc(ctx,person.id)+'">Remove</button></div>':'',
      '</div>'
    ].join('')).join('');
  }
  const oldSummary=p.renderClientSummary;
  if (typeof oldSummary==='function') p.renderClientSummary=function(client) {
    const html=oldSummary.call(this,client);
    const count=state(this).get(String(client.id))?.rows?.length||0;
    const markup='<div class="aa-additional-contacts-summary" data-aa-contact-summary="'+esc(this,client.id)+'"'+(!count?' hidden':'')+'>'+
      '<strong>Additional Owners & Contacts</strong><div data-aa-contact-list>'+
      display(this,client.id,false)+'</div></div>';
    return html.replace('</section>',markup+'</section>');
  };
  const oldEdit=p.renderEditClient;
  if (typeof oldEdit==='function') p.renderEditClient=function(client) {
    const html=oldEdit.call(this,client);
    const anchor='<div class="aa-client-edit__group-heading">Internal Administration';
    if(!html.includes(anchor))return html;
    const markup=[
      '<div class="aa-client-contacts" data-aa-contacts-panel="',esc(this,client.id),'">',
      '<div class="aa-client-contacts__header"><div><h3>Additional Owners & Contacts</h3>',
      '<p>Add another owner, manager, or contact. Listing someone here does not grant a login or signing rights.</p></div>',
      '<button class="aa-button aa-button--secondary" type="button" data-aa-contact-add>+ Add Contact</button></div>',
      '<div data-aa-contact-list class="aa-client-contacts__list">',display(this,client.id,true),'</div>',
      '<div class="aa-client-contacts__editor" data-aa-contact-editor hidden>',
      '<strong data-aa-contact-title>Add Contact</strong>',
      '<div class="aa-client-contacts__fields">',
      '<label>Full Name<input type="text" data-aa-contact-name maxlength="160" placeholder="Owner or contact name"></label>',
      '<label>Role<select data-aa-contact-role><option>Owner</option><option>Co-owner</option><option>Store Manager</option><option>Marketing Contact</option><option>Other</option></select></label>',
      '<label>Email<input type="email" data-aa-contact-email maxlength="254"></label>',
      '<label>Phone<input type="tel" data-aa-contact-phone maxlength="60"></label>',
      '</div><div class="aa-client-contacts__actions">',
      '<button class="aa-button aa-button--primary" type="button" data-aa-contact-save>Save Contact</button>',
      '<button class="aa-button aa-button--secondary" type="button" data-aa-contact-cancel>Cancel</button>',
      '</div></div><p class="aa-client-contacts__feedback" data-aa-contact-feedback role="status" aria-live="polite"></p>',
      '</div>'
    ].join('');
    return html.replace(anchor,markup+anchor);
  };
  p.__aaUpdateContactsUI=function(clientId){
    const id=String(clientId);
    const summary=this.root.querySelector('[data-aa-contact-summary="'+id+'"]');
    if(summary) summary.hidden=!(state(this).get(id)?.rows?.length);
    for(const host of this.root.querySelectorAll('[data-aa-contact-summary="'+id+'"] [data-aa-contact-list], [data-aa-contacts-panel="'+id+'"] [data-aa-contact-list]')){
      const editable=Boolean(host.closest('[data-aa-contacts-panel]'));
      host.innerHTML=display(this,id,editable);
    }
  };
  p.__aaLoadContacts=async function(clientId,force=false){
    if(!clientId)return;
    const id=String(clientId), cache=state(this), current=cache.get(id);
    if(current && !force){if(current.loading)return current.promise;if(!current.error)return;}
    const snapshot={loading:true,rows:current?.rows||[],error:''};
    cache.set(id,snapshot);
    const promise=(async()=>{
      try{
        const db=window.AASupabaseClient?.getClient?.();
        if(!db)throw Error('Connection unavailable.');
        const {data,error}=await db.from(TABLE).select('id,client_id,full_name,contact_role,email,phone,created_at')
          .eq('client_id',id).order('created_at',{ascending:true});
        if(error)throw error;
        if(cache.get(id)!==snapshot)return;
        cache.set(id,{loading:false,error:'',rows:Array.isArray(data)?data:[]});
      }catch(e){
        if(cache.get(id)!==snapshot)return;
        cache.set(id,{loading:false,error:e?.message||'Unknown error',rows:current?.rows||[]});
      }
      this.__aaUpdateContactsUI(id);
    })();
    snapshot.promise=promise;
    this.__aaUpdateContactsUI(id);
    return promise;
  };
  const oldRender=p.render;
  if(typeof oldRender==='function')p.render=function(...args){
    const result=oldRender.apply(this,args);
    if(this.activeClientId && (this.activeClientTab==='overview' ||
        String(this.editingClientId)===String(this.activeClientId))) {
      void this.__aaLoadContacts(this.activeClientId);
    }
    return result;
  };
  const oldBind=p.bindClientActions;
  if(typeof oldBind==='function')p.bindClientActions=function(){
    oldBind.call(this);
    if(this.__aaContactsBound)return;
    this.__aaContactsBound=true;
    this.root.addEventListener('click',async event=>{
      const btn=event.target.closest?.('[data-aa-contact-add],[data-aa-contact-edit],[data-aa-contact-remove],[data-aa-contact-save],[data-aa-contact-cancel]');
      if(!btn)return;
      const panel=btn.closest('[data-aa-contacts-panel]');
      if(!panel)return;
      event.preventDefault();
      const clientId=panel.dataset.aaContactsPanel;
      if(String(this.editingClientId)!==String(clientId) || String(this.activeClientId)!==String(clientId))return;
      const editor=panel.querySelector('[data-aa-contact-editor]');
      const full=panel.querySelector('[data-aa-contact-name]');
      const role=panel.querySelector('[data-aa-contact-role]');
      const email=panel.querySelector('[data-aa-contact-email]');
      const phone=panel.querySelector('[data-aa-contact-phone]');
      const feedback=panel.querySelector('[data-aa-contact-feedback]');
      const say=msg=>{if(feedback) feedback.textContent=msg;};
      const people=state(this).get(String(clientId))?.rows||[];
      if(btn.hasAttribute('data-aa-contact-add')){
        editor.dataset.contactId='';full.value='';role.value='Owner';email.value='';phone.value='';
        editor.querySelector('[data-aa-contact-title]').textContent='Add Contact';
        editor.hidden=false;full.focus();return;
      }
      if(btn.hasAttribute('data-aa-contact-cancel')){editor.hidden=true;return;}
      if(btn.hasAttribute('data-aa-contact-edit')){
        const person=people.find(x=>String(x.id)===btn.dataset.aaContactEdit);
        if(!person){say('Contact not found. Reopen Client Info.');return;}
        editor.dataset.contactId=person.id;
        full.value=person.full_name||'';role.value=person.contact_role||'Other';
        email.value=person.email||'';phone.value=person.phone||'';
        editor.querySelector('[data-aa-contact-title]').textContent='Edit Contact';
        editor.hidden=false;full.focus();return;
      }
      const db=window.AASupabaseClient?.getClient?.();
      if(!db){say('Connection unavailable.');return;}
      if(btn.hasAttribute('data-aa-contact-remove')){
        const person=people.find(x=>String(x.id)===btn.dataset.aaContactRemove);
        if(!person || !window.confirm('Remove '+person.full_name+' from additional contacts? This does not change client access or contracts.'))return;
        btn.disabled=true;
        try{
          const {data,error}=await db.from(TABLE).delete().eq('client_id',clientId).eq('id',person.id).select('id');
          if(error)throw error;if(!data?.length)throw Error('Removal was not confirmed.');
          await this.__aaLoadContacts(clientId,true);say('Contact removed.');
        }catch(e){say(e?.message||'Unable to remove contact.');}
        finally{if(btn.isConnected)btn.disabled=false;}
        return;
      }
      if(btn.hasAttribute('data-aa-contact-save')){
        const name=full.value.trim(),address=email.value.trim();
        if(!name){say('Enter a contact name.');full.focus();return;}
        if(address && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)){say('Enter a valid email address.');return;}
        const payload={full_name:name,contact_role:role.value,email:address||null,phone:phone.value.trim()||null,updated_at:new Date().toISOString()};
        const id=editor.dataset.contactId||'';
        btn.disabled=true;btn.textContent='Saving...';
        try{
          const request=id ? db.from(TABLE).update(payload).eq('client_id',clientId).eq('id',id).select('id').single()
            : db.from(TABLE).insert({...payload,client_id:clientId}).select('id').single();
          const {data,error}=await request;
          if(error)throw error;if(!data?.id)throw Error('Save was not confirmed.');
          editor.hidden=true;await this.__aaLoadContacts(clientId,true);say('Contact saved. Signing and workspace access are unchanged.');
        }catch(e){say(e?.message||'Contact could not save.');}
        finally{if(btn.isConnected){btn.disabled=false;btn.textContent='Save Contact';}}
      }
    });
  };
  p.__aaContactsFeature=true;
})();